/*
 * Public API Surface of sia-file-preview
 */

// File Preview - Dialog
export * from './lib/dialogs/sia-file-preview-dialog/sia-file-preview-dialog.component';

// File Preview - Components
export * from './lib/components/file-preview-handler/file-preview-handler.component';
export * from './lib/components/file-preview-image/file-preview-image.component';
export * from './lib/components/file-preview-excel/file-preview-excel.component';
export * from './lib/components/file-preview-email/file-preview-email.component';

// File Preview - Services & Interfaces
export * from './lib/services/file-preview.service';
export * from './lib/services/file-preview-provider.interface';
export * from './lib/services/file-system-preview.provider';
export * from './lib/interfaces/file-preview.interface';

// File Preview - APIs
export * from './lib/apis/file-preview.api';
